import validate from "/home/galadriel/az-agent/_work/1/s/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/home/galadriel/az-agent/_work/1/s/middleware/auth.global.js";
import feedback_45global from "/home/galadriel/az-agent/_work/1/s/middleware/feedback.global.js";
import i18n_45global from "/home/galadriel/az-agent/_work/1/s/middleware/i18n.global.ts";
import redirect_45trailing_45slash_45global from "/home/galadriel/az-agent/_work/1/s/middleware/redirectTrailingSlash.global.ts";
import redirects_45global from "/home/galadriel/az-agent/_work/1/s/middleware/redirects.global.ts";
import manifest_45route_45rule from "/home/galadriel/az-agent/_work/1/s/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  feedback_45global,
  i18n_45global,
  redirect_45trailing_45slash_45global,
  redirects_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}